import React from "react";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {schemaResetPassword} from "../constants/schema-reset-password";
import TextFormField from "@common/components/forms/text-form-field";
import AppButton from "@common/components/app-button";
import {useNavigate} from "react-router-dom";
import useAuth from "../hooks/use-auth";
import PasswordFormField from "@common/components/forms/password-form-field";

interface ResetPasswordFormProps {
    token: string;
}

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({token}) => {
    const {resetPassword, loading} = useAuth();
    const navigate = useNavigate();

    const methods = useForm({
        resolver: yupResolver(schemaResetPassword),
        defaultValues: {
            token: token,
            password: '',
            confirmPassword: '',
        },
        mode: "onSubmit",
    });

    const {handleSubmit, formState: {isSubmitting}} = methods;

    const handleResetPassword = async (data: { token: string; password: string; confirmPassword: string }) => {
        await resetPassword(data.password, data.token);
    };

    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(handleResetPassword)} className="space-y-6">
                <TextFormField
                    name="token"
                    label="Token"
                    placeholder="Token"
                    forceDisabled={true}
                />

                <PasswordFormField
                    name="password"
                    label="Nowe hasło"
                    placeholder="Wprowadź nowe hasło"
                    showPasswordToggle={true}
                />

                <PasswordFormField
                    name="confirmPassword"
                    label="Potwierdź nowe hasło"
                    placeholder="Potwierdź nowe hasło"
                    showPasswordToggle={true}
                />

                {methods.formState.errors.root && (
                    <div className="text-red-600 text-sm text-center">
                        {methods.formState.errors.root.message}
                    </div>
                )}

                <div className="flex items-center justify-between">
                    <AppButton
                        onClick={() => navigate("/login")}
                        type='button'
                        disabled={isSubmitting || loading}
                        label="Cofnij"
                        className='!rounded-[4rem] !border-none text-primary text-[1rem] h-[40px] font-semibold bg-primary-alt hover:bg-primary-alt/80'/>

                    <AppButton
                        type='submit'
                        loading={isSubmitting || loading}
                        label="Zresetuj hasło"
                        className='!rounded-[4rem] text-on-primary text-[1rem] h-[40px] font-semibold bg-primary hover:bg-primary/80'/>
                </div>
            </form>
        </FormProvider>
    );
};

export default ResetPasswordForm;
